module.exports = __webpack_public_path__ + "img/jwgl-xk-xb.67b463d1.png";